import React, { useEffect, useState, useContext } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { getPropertyDetail } from '../services/Api';
import Footer from '../components/Footer';
import { HiChevronLeft, HiChevronRight } from "react-icons/hi";
import { FiMapPin, FiCalendar, FiCheckSquare, FiHome } from 'react-icons/fi';
import InquiryForm from '../components/InquiryForm';
import { GlobalContext } from '../GlobalContext';
import ContactForm from "../components/ContactForm";
import { Helmet } from 'react-helmet';
import ChatBot from '../components/ChatBot';
import i18n from 'i18next';
import { useTranslation } from 'react-i18next';
import { FaHeart, FaRegHeart } from 'react-icons/fa';
import { toast } from 'react-toastify';
import { useLocation } from "react-router-dom";
import { checkPropertySaved, toggleSaveProperty } from '../services/Api';



export default function PropertyDetailsPage() {
  const { idOrSlug } = useParams();
  const [property, setProperty] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [current, setCurrent] = useState(0);
  const [amenitiesData, setAmenitiesData] = useState([]);
  const [unitTypeData, setUnitTypedata] = useState([]);
  const [downloading, setDownloading] = useState(false);
  const { globalVar } = useContext(GlobalContext);
  const navigate = useNavigate();
  const [zoomImage, setZoomImage] = useState(null);
  const [saving, setSaving] = useState(false);
  const isLoggedIn = localStorage.getItem("accessToken");
  const { id } = useParams(); // ✅ fix here
  const [savedProperties, setSavedProperties] = useState({});
  const location = useLocation();
  const [savingId, setSavingId] = useState(null);
  const [isSaved, setIsSaved] = useState(location.state?.isSaved || false);

  const handleImageClick = (url) => setZoomImage(url);
  const closeZoom = () => setZoomImage(null);

  const tabs = ["Overview", "Payment Plan", "Available Units","Sales Offer","Marketing Material"];
  const [activeTab, setActiveTab] = useState("Overview");

  const { t } = useTranslation();


  const changeLanguage = (lng) => {
  i18n.changeLanguage(lng);
  document.dir = lng === 'ar' ? 'rtl' : 'ltr'; // Optional: adjust layout direction
};



const fetchPropertyDetail = async () => {
    setLoading(true);
    try {
      const response = await getPropertyDetail(idOrSlug);
      if (response.success) {
        const prop = response.data.data;
       
        setProperty(prop);
        setAmenitiesData(response.data.amenity_list);
        setUnitTypedata(response.data.unit_type_name);
        if (!isNaN(idOrSlug)) {
          navigate(`/property-detail/${prop.slug}`, { replace: true });
        }
       if (isLoggedIn) {
        try {
          const res = await checkPropertySaved(prop.id);
          setIsSaved(res.is_saved);
        } catch (err) {
          console.error("Failed to fetch save status:", err);
        }
      }
    } else {
      setError("Property not found");
    }
    } catch (err) {
      setError("Failed to fetch property details");
    } finally {
      setLoading(false);
    }
  };

useEffect(() => {
  fetchPropertyDetail();
}, [idOrSlug, i18n.language]);



  const prev = () => setCurrent(i => (i === 0 ? property.images.length - 1 : i - 1));
  const next = () => setCurrent(i => (i === property.images.length - 1 ? 0 : i + 1));

  

  const handleToggleSave = async () => {
    if (!isLoggedIn) {
      toast.warning("Please log in to save properties");
      return;
    }

    setSaving(true);
    try {
      const res = await toggleSaveProperty(property.id);
      setIsSaved(res.is_saved);
      toast.success(res.message || "Updated successfully!");
    } catch (err) {
      toast.error("Failed to update save status");
      console.error("Toggle save error:", err);
    } finally {
      setSaving(false);
    }
  };

  const getImageUrl = (path) => `${globalVar}/${path}`;
  const handleDownloadPDF = async () => {
    try {
      setDownloading(true); // show loader

      const response = await fetch(`http://127.0.0.1:8000/api/v1/property-salesoffer/${property.slug}/`);
      if (!response.ok) throw new Error('Download failed');

      const blob = await response.blob();
      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = `Property-${property.slug}.pdf`;
      document.body.appendChild(link);
      link.click();
      link.remove();
      URL.revokeObjectURL(url);
    } catch (err) {
      console.error('Error downloading PDF:', err);
    } finally {
      setDownloading(false); // hide loader
    }
  };

  const sendWhatsApp = () => {
    const phone = "971552554245";
    const currentUrl = window.location.href;
    const title = property?.title || "this property";
    const message = `Hi! I'm interested in ${title}:\n${currentUrl}\nCan you share the full details and best offer?`;
    const encodedMessage = encodeURIComponent(message);
    const isMobile = /Android|iPhone|iPad|iPod|Windows Phone/i.test(navigator.userAgent);
    const baseUrl = isMobile
      ? `https://wa.me/${phone}?text=${encodedMessage}`
      : `https://web.whatsapp.com/send?phone=${phone}&text=${encodedMessage}`;
    window.open(baseUrl, '_blank');
  };

  const tableHeader = {
    backgroundColor: '#444',
    color: '#fff',
    padding: '8px',
    border: '1px solid #ccc',
    fontWeight: 'bold',
    textAlign: 'left'
  };

  const tableCell = {
    backgroundColor: '#f9f9f9',
    padding: '8px',
    border: '1px solid #ccc'
  };

  if (loading) {
    return (
      <div className="text-center mt-20">
        <svg
          className="animate-spin h-8 w-8 text-teal-500 mx-auto"
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
        >
          <circle
            className="opacity-25"
            cx="12"
            cy="12"
            r="10"
            stroke="currentColor"
            strokeWidth="4"
          ></circle>
          <path
            className="opacity-75"
            fill="currentColor"
            d="M4 12a8 8 0 018-8v4l3-3-3-3v4a8 8 0 00-8 8h4z"
          ></path>
        </svg>
      </div>
    );
  }

  if (error) return <div className="text-center text-red-500 mt-20">{error}</div>;



  return (
    <div className="space-y-12 mt-24">
      <ChatBot propertyId={property?.id}/>



  {/* 3. The rest of your layout here... */}


      <div className="max-w-7xl mx-auto px-4 grid grid-cols-1 lg:grid-cols-3 gap-8">
        <div className="lg:col-span-2">
                    {property && (
            <Helmet>
              <title>{property.title}</title>
              <meta name="description" content={property.description?.slice(0, 150)} />
              <meta property="og:image" content={getImageUrl(property.images[0]?.image.replace(/_[^/]+(?=\.\w+$)/, ''))} />
            </Helmet>
          )}

          {property?.images?.length > 0 && (
            <div className="w-full relative overflow-hidden rounded-2xl">
              <img
                src={getImageUrl(property.images[current].image.replace(/_[^/]+(?=\.\w+$)/, ''))}
                alt={`Slide ${current + 1}`}
                sizes="(max-width: 640px) 100vw, (max-width: 1024px) 50vw, 25vw"
                width="300"
                height="300"
                className="h-98 w-full object-cover"
                loading="lazy"
                
              />
              <button
                onClick={prev}
                className="absolute top-1/2 left-2 transform -translate-y-1/2 bg-white bg-opacity-70 hover:bg-opacity-100 p-2 rounded-full"
              >
                <HiChevronLeft size={24} />
              </button>
              <button
                onClick={next}
                className="absolute top-1/2 right-2 transform -translate-y-1/2 bg-white bg-opacity-70 hover:bg-opacity-100 p-2 rounded-full"
              >
                <HiChevronRight size={24} />
              </button>
            </div>
            
          )}
          <div className="mt-4 flex gap-2 overflow-x-auto">
          {property.images.map((imgObj, index) => (
            <img
              key={index}
              onClick={() => setCurrent(index)}
              src={getImageUrl(imgObj.image.replace(/_[^/]+(?=\.\w+$)/, ''))}
              alt={`Thumbnail ${index + 1}`}
              className={`w-24 h-16 object-cover rounded-lg cursor-pointer border-2 transition-all ${
                current === index ? 'border-emerald-600' : 'border-transparent'
              }`}
            />
          ))}
        </div>

          <div className="py-12 space-y-8 relative">
            {isLoggedIn && (
              <button
                onClick={handleToggleSave}
                disabled={saving}
                className="absolute top-13 right-5 text-teal-500 text-xl hover:scale-110 transition-transform"
              >
                {isSaved ? <FaHeart /> : <FaRegHeart />}
              </button>
            )}
            <h1 className="text-4xl font-bold text-gray-900"> {i18n.language === 'ar' && property.title_ar
    ? property.title_ar
    : property.title}</h1>
    
            <p className="flex items-center text-gray-600 mt-2">
              <FiMapPin className="text-emerald-500 mr-2" /> {t(`emirates.${property.location?.emirate?.toLowerCase().replaceAll(' ', '_')}`, property.location?.emirate)}
             {property.community?.name
  ? ` / ${t(`communities.${property.community.name.toLowerCase().replace(/ /g, '_')}`, property.community.name)}`
  : ''}

              {/* <FiMapPin className="mr-1" /> {property.location.emirate} */}
            </p>

            <div className="grid grid-cols-2 sm:grid-cols-4 gap-6 text-center">
              <div>
                 <p className="text-sm text-gray-500">{t('tabs.starting_price')}</p>
<p className="text-xl font-semibold text-emerald-500">
 {property.price > 0
    ? i18n.language === 'ar'
      ? `${Math.round(property.price).toLocaleString()} ${t('currency.dirham')}`
      : `${t('currency.dirham')} ${Math.round(property.price).toLocaleString()}`
    : t('currency.ask_for_price')}
</p>

              </div>
              <div>
                <p className="text-sm text-gray-500">{t('tabs.area')}</p>
                <p className="text-xl font-semibold text-emerald-500">
                <span>
  {i18n.language === 'ar'
    ? `${property.area_sqft.toLocaleString()} ${t("static.sqft")}`
    : `${property.area_sqft.toLocaleString()} ${t("static.sqft")}`}
</span>
                </p>
              </div>
              <div>
               <p className="text-sm text-gray-500">{t('tabs.rooms')}</p>
                <p className="text-xl font-semibold text-emerald-500">
                  {[...new Set(property.units.map(unit => unit.rooms))]
                    .filter(room => room && room !== "Studio") 
                    .sort((a, b) => Number(a) - Number(b))
                    .join(', ')}
                </p>
              </div>
            </div>

<nav className="flex gap-4 mt-10">
  {tabs.map((tab) => (
    <button
      key={tab}
      onClick={() => setActiveTab(tab)}
      className={`relative px-5 py-2 rounded-full font-medium text-sm transition-all duration-200
        ${
          activeTab === tab
            ? 'bg-white text-emerald-600 border border-emerald-600 after:content-[""] after:absolute after:-bottom-1 after:left-1/2 after:-translate-x-1/2 after:w-6 after:h-1 after:bg-emerald-500 after:rounded-full'
            : 'bg-white text-gray-600 border border-gray-300 hover:text-emerald-600 hover:border-emerald-300'
        }
      `}
    >
      {tab}
    </button>
  ))}
</nav>


            <div className="mt-6 text-gray-700">
              {activeTab === 'Overview' && (
                <div
  className="prose prose-lg text-gray-600 text-justify"
  dangerouslySetInnerHTML={{
    __html:
      i18n.language === 'ar' && property.description_ar
        ? property.description_ar
        : property.description,
  }}
/>

              )}
              {activeTab === 'Overview' && (
  <>
{amenitiesData?.length > 0 && (
  <div className="mt-8">
    <h2 className="text-xl font-semibold text-gray-800 mb-4">
      {t('amenities.amenities_section_title')}
    </h2>
    <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
      {amenitiesData.map((amenityKey, id) => (
        <div
          key={id}
          className="flex items-center gap-3 bg-gray-50 p-3 rounded-lg shadow-sm border border-gray-200"
        >
          <FiCheckSquare className="text-emerald-500" />
          <span className="text-sm font-medium text-gray-700">
            {t(`amenities.${amenityKey}`, amenityKey)}
          </span>
        </div>
      ))}
    </div>
  </div>
)}


<div className="mt-6">
  <h2 className="text-xl font-semibold text-gray-800 mb-4">Location</h2>
  <div className="rounded-xl overflow-hidden shadow-md border border-gray-200">
    <iframe
      title="property-map"
      width="100%"
      height="300"
      style={{ border: 0 }}
      loading="lazy"
      allowFullScreen
      referrerPolicy="no-referrer-when-downgrade"
      src={`https://www.google.com/maps?q=${property.location.latitude},${property.location.longitude}&hl=es;z=14&output=embed`}
    ></iframe>
  </div>
</div>
          <div>
              <h2 className="text-2xl font-bold text-gray-900 mb-4 mt-4">Key Details</h2>
              <div className="grid grid-cols-1 sm:grid-cols-3 gap-6 text-gray-700">
                <div className="flex items-center">
                  <FiMapPin className="text-emerald-500 mr-2" />
                  <div>
                    <p className="text-sm text-gray-500">Developer</p>
                    <p>{property.developer.name}</p>
                  </div>
                </div>
                {/* <div className="flex items-center">
                  <FiHome className="text-emerald-500 mr-2" />
                  <div>
                    <p className="text-sm text-gray-500">Unit Type</p>
                    <p>{property.unit_type?.replace(/[{}"']/g, '').trim()}</p>
                  </div>
                </div> */}
                <div className="flex items-center">
                  <FiCalendar className="text-emerald-500 mr-2" />
                  <div>
                    <p className="text-sm text-gray-500">Handover</p>
                    <p>{property.delivery_date}</p>
                  </div>
                </div>
                <div className="flex items-center">
                  <FiCheckSquare className="text-emerald-500 mr-2" />
                  <div>
                    <p className="text-sm text-gray-500">Status</p>
                    <p>{property.sales_status}</p>
                  </div>
                </div>
              </div>
            </div>
  </>
)}

{activeTab === 'Payment Plan' && (
  <div className="space-y-6">
    {property.payment_plans.map((plan) => (
      <div
        key={plan.id}
        className="border border-gray-200 rounded-xl shadow-sm bg-white p-6 space-y-4"
      >
        <div className="flex items-center justify-between">
          <h3 className="text-lg font-bold text-gray-800">
            {plan.name}
          </h3>
          <span className="text-sm bg-emerald-100 text-emerald-700 px-3 py-1 rounded-full">
            {plan.description}
          </span>
        </div>

        <div className="divide-y divide-gray-100">
          {plan.values.map((value) => (
            <div
              key={value.id}
              className="flex justify-between py-3 text-sm text-gray-700"
            >
              <span className="font-medium">{value.name}</span>
              <span>{value.value}</span>
            </div>
          ))}
        </div>
      </div>
    ))}
  </div>
)}
{activeTab === 'Available Units' && (
  <div className="grid grid-cols-1 sm:grid-cols-1 lg:grid-cols-2 gap-6">
    {property.units.map((unit, index) => (
      <div
        key={index}
        className="bg-white rounded-xl border border-gray-200 shadow-sm hover:shadow-md transition-all overflow-hidden"
      >
        {/* Image */}
        {unit.floorplans?.[0]?.images?.[0]?.url && (
          <img
            src={unit.floorplans[0].images[0].url}
            alt={`Unit ${index + 1} Floor Plan`}
            className="w-full h-64 object-contain cursor-pointer bg-gray-100"
            onClick={() => handleImageClick(unit.floorplans[0].images[0].url)}
          />
        )}

        {/* Details */}
        <div className="p-4 space-y-2">
          <h3 className="text-lg font-bold text-gray-800">{unit.unit_type}</h3>
          <p className="text-sm text-gray-500">Configuration: {unit.rooms || 'N/A'} rooms</p>

          <div className="flex justify-between text-sm text-gray-700 pt-2 border-t border-gray-100">
            <div>
              <p className="text-gray-500">Min Price</p>
              <p className="font-semibold text-emerald-600">AED {Number(unit.min_price).toLocaleString()}</p>
            </div>
            <div>
              <p className="text-gray-500">Min Area</p>
              <p className="font-semibold">{unit.min_area} sqft</p>
            </div>
          </div>
        </div>
      </div>
    ))}
  </div>
)}
{activeTab === 'Marketing Material' && (
  <div className="mt-6">
    <h2 className="text-2xl font-bold text-gray-900 mb-4">Marketing Material</h2>

    <div className="aspect-w-16 aspect-h-20 h-98 bg-gray-100 border border-gray-300 rounded-lg overflow-hidden flex items-center justify-center">
      {property?.units?.[0]?.youtube_url ? (
        <iframe
          width="100%"
          height="100%"
          src={`https://www.youtube.com/embed/${extractYouTubeID(property.units[0].youtube_url)}`}
          title="Marketing Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      ) : (
        <p className="text-gray-500 text-center">No marketing materials available.</p>
      )}
    </div>
  </div>
)}

{/* {activeTab === 'Marketing Material' && (
  <div ref={marketingMaterialRef} className="mt-6">
    <h2 className="text-2xl font-bold text-gray-900 mb-4">Marketing Material</h2>

    <div className="aspect-w-16 aspect-h-20 h-98 bg-gray-100 border border-gray-300 rounded-lg overflow-hidden">
      {property?.units?.[0]?.youtube_url && (
        <iframe
          width="100%"
          height="100%"
          src={`https://www.youtube.com/embed/${extractYouTubeID(property.units[0].youtube_url)}`}
          title="Marketing Video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      )}
    </div>
  </div>
)} */}

{activeTab === 'Sales Offer' && (
  <div className="space-y-6">
    {/* 🧾 Download PDF Button */}
    <div className="flex justify-start">
      <button
        onClick={handleDownloadPDF}
        disabled={downloading}
        // className="fixed bottom-6 left-6 z-50 flex items-center justify-center w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg disabled:opacity-60 disabled:cursor-not-allowed"
        className="inline-flex items-center gap-2 px-5 py-3 rounded-lg bg-teal-500 hover:bg-teal-600 text-white font-semibold shadow  transition-all duration-200 disabled:opacity-60 disabled:cursor-not-allowed"
      >
        {downloading ? (
          <>
            <svg className="animate-spin h-5 w-5 text-white" fill="none" viewBox="0 0 24 24">
              <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4" />
              <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z" />
            </svg>
            Downloading...
          </>
        ) : (
          <>
            <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1M12 12v6m0 0l-3-3m3 3l3-3m0-9h-6a2 2 0 00-2 2v1" />
            </svg>
            Download PDF
          </>
        )}
      </button>
      {/* <a
        href={`http://127.0.0.1:8000/api/v1/property-salesoffer/${property.slug}/`}
        target="_blank"
        rel="noopener noreferrer"
        className="inline-flex items-center gap-2 px-5 py-3 rounded-lg bg-blue-600 text-white font-semibold shadow hover:bg-blue-700 transition-all duration-200"
      >
        <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1M12 12v6m0 0l-3-3m3 3l3-3m0-9h-6a2 2 0 00-2 2v1" />
        </svg>
        Download PDF
      </a> */}
    </div>
  </div>
)}
 
            </div>

  
          </div>
        </div>

<div className="lg:col-span-1">
  <div className="sticky top-24">
   <ContactForm
  leadType="email"
  propertyTitle={property?.title || ""}
  propertySlug={property?.slug || ""}
  developerName={property?.developer?.name || ""}
/>
                      <div className="mt-4 flex justify-center">
                    {/* <button
                      onClick={sendWhatsApp}
                      className="fixed mb-26 bottom-6 right-6 z-50 flex items-center justify-center w-14 h-14 bg-green-500 hover:bg-green-600 rounded-full shadow-lg"
                      aria-label="Chat on WhatsApp"
                    >
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        fill="white"
                        viewBox="0 0 24 24"
                        className="w-6 h-6"
                      >
                        <path d="M20.52 3.48A11.85 11.85 0 0012 0C5.373 0 0 5.373 0 12a11.865 11.865 0 001.643 6.165L0 24l5.887-1.552A11.87 11.87 0 0012 24c6.627 0 12-5.373 12-12 0-3.196-1.246-6.205-3.48-8.52zM12 21.5a9.4 9.4 0 01-4.836-1.42l-.346-.207-3.494.92.93-3.403-.22-.355A9.392 9.392 0 012.5 12c0-5.247 4.253-9.5 9.5-9.5s9.5 4.253 9.5 9.5-4.253 9.5-9.5 9.5zm5.292-7.41c-.26-.13-1.54-.76-1.78-.85-.237-.09-.41-.13-.584.13-.17.26-.65.85-.8 1.02-.15.17-.3.19-.56.07-.26-.13-1.1-.4-2.1-1.3-.78-.7-1.3-1.58-1.45-1.84-.15-.26-.015-.4.12-.53.12-.12.26-.3.39-.44.13-.15.17-.26.26-.43.09-.17.04-.32-.02-.44-.06-.13-.58-1.4-.8-1.9-.21-.5-.43-.43-.59-.44-.15-.01-.32-.01-.49-.01-.16 0-.44.06-.67.32-.22.26-.85.83-.85 2.02s.87 2.34 1 2.5c.13.17 1.72 2.62 4.18 3.68.58.25 1.03.4 1.38.52.58.2 1.1.17 1.52.1.46-.08 1.4-.57 1.6-1.12.17-.44.17-.82.12-.9-.04-.07-.18-.12-.38-.22z" />
                      </svg>
                    </button> */}

</div>
  </div>
</div>


      </div>

      

      <Footer />
      {zoomImage && (
  <div
    className="fixed inset-0 bg-black bg-opacity-70 flex items-center justify-center z-50"
    onClick={closeZoom}
  >
    <div className="max-w-3xl max-h-[80vh] overflow-auto rounded-lg shadow-lg">
      <img src={zoomImage} alt="Zoomed Floor Plan" className="w-full h-auto object-contain" />
    </div>
    <button
      onClick={closeZoom}
      className="absolute top-6 right-6 text-white text-3xl font-bold"
    >
      &times;
    </button>
  </div>
)}
    </div>
  );
}